import { put, call } from 'redux-saga/effects';
import actions from './actions';
import Api from '../../helpers/api';
import { sendRequest } from '../../helpers/saga';

const startAppApi = new Api('start_app_settings');

function* getStartAppSettings() {
  const result = yield call(sendRequest, startAppApi.load, {}, actions.GET_START_APP_SETTINGS_ERROR);

  if (result?.data?.success?.data) {
    const { start_app_settings } = result.data.success.data;

    yield put(actions.getStartAppSettingsCompleted(start_app_settings));
  }
}

export { getStartAppSettings };
